import config from "../config";
import Trace from "./snake.lib.trace";

export default class Url {
    static parseQueryString = () => {
        return new URLSearchParams(window.location.search);
    };

    static getCurrentUri = () => {
        return window.location.pathname;
    };

    static getParametes = (params) => {
        try {
            const getValue = (param) => {
                let value = null;
                const paramValue = queryString.get(param);

                if (paramValue !== null) value = paramValue.length === 0 ? true : paramValue;

                return value;
            };

            const queryString = Url.parseQueryString();

            if (typeof params === "string") {
                return getValue(params);
            } else if (typeof params === "object") {
                const values = [];

                params.forEach((param) => values.push(getValue(param)));

                return values;
            }

            return null;
        } catch (e) {
            Trace.error(e);
        }
    };

    static getSnakeApiUrl = () => {
        const country = window.snakeCheckout.currentCountry.toUpperCase();

        return [config.countries.es.countryCode, config.countries.fr.countryCode, config.countries.be.countryCode].includes(country) && import.meta.env.CO_BRAND === config.brands.pw ? import.meta.env[`CO_SNAKE_API_${country}`] : import.meta.env.CO_SNAKE_API;
    };
}
